<template>
  <div style="width: 100%">
    <vxe-table border auto-resize resizable show-overflow :data="tableData">
      <!-- <vxe-table-column type="seq" title="序号" width="60"></vxe-table-column> -->
      <vxe-table-column type="expand" width="60">
        <template #content="{ row }">
          <ExpandTable :fetchTableData="row.invoiceList" />
        </template>
      </vxe-table-column>
      <vxe-table-column
        v-for="(item, index) of tableColumn"
        :key="index"
        :field="item.field"
        :title="item.title"
        :edit-render="item.itemRender"
        :minWidth="item.width"
      >
      </vxe-table-column>
    </vxe-table>
  </div>
</template>

<script>
  import ExpandTable from './ExpandTable';
  export default {
    name: 'InvoiceInformationExpandTable',
    props: {
      fetchTableData: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        tableColumn: [
          {
            title: '应开票金额',
            field: 'invoiceAmount',
            width: 150,
          },

          {
            title: '已开票金额',
            field: 'invoicedAmount',
            width: 150,
          },
          {
            title: '未开票金额',
            field: 'uninvoiceAmount',
            width: 150,
          },
        ],
        tableData: [],
      };
    },
    components: {
      ExpandTable,
    },
    watch: {
      fetchTableData: {
        handler(val) {
          if (val && Object.keys(val).length) {
            this.tableData = [
              {
                uninvoiceAmount: val.uninvoiceAmount,
                invoicedAmount: val.invoicedAmount,
                invoiceAmount: val.invoiceAmount,
                invoiceList: val.invoiceList,
              },
            ];
          }
        },
        immediate: true,
      },
    },
  };
</script>

<style lang="scss" scoped></style>
